import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { useForm } from "react-hook-form";
import { useRecoilState } from "recoil";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import { isEditCandidateModalOpenState } from "../../../../recoil/admin/examRoom";
import Modal from "../../../modules/layout/Modal";
import { phoneRegex, emailRegex } from "../../../../api/regex";

const CandidateEditModal = ({ selectedCandidate }) => {
	const { editCandidateDate } = useExamRoomActions();
	const [isEditCandidateModalOpen, setEditCandidateModalOpen] = useRecoilState(
		isEditCandidateModalOpenState
	);

	// Access the client
	const queryClient = useQueryClient();

	// Mutations
	const mutation = useMutation(editCandidateDate, {
		onSuccess: () => {
			alert("정보를 수정했습니다.");
			setEditCandidateModalOpen(false);
			//   reset();
			// Invalidate and refetch
			queryClient.invalidateQueries(["fetchCandidateList"]);
		},
		onError: () => {
			alert("실패");
		},
	});

	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm();

	const onSubmit = (data) => {
		const req = {
			sn: selectedCandidate?.sn,
			name: data.name,
			email: data.email,
			birthday: data.birthday,
			tel: data.tel,
			tel2: data.tel2,
		};

		if (!req.sn) {
			return alert("오류!");
		} else if (!req.name) {
			return alert("이름을 입력해주세요.");
		} else if (!req.email) {
			return alert("이메일을 입력해주세요.");
		} else if (!emailRegex.test(req.email)) {
			return alert("이메일이 올바르지 않습니다.");
		} else if (!req.birthday) {
			return alert("생년월일을 입력해주세요.");
		} else if (!req.birthday.length !== 8) {
			return alert("생년월일을 입력해주세요.");
		} else if (!req.tel) {
			return alert("전화번호를 입력해주세요");
		} else if (!phoneRegex.test(req.tel)) {
			return alert("올바른 전화번호를 입력하세요.");
		} else if (req.tel2 !== "" && !phoneRegex.test(req.tel2)) {
			return alert("휴대폰 번호는 XXX-XXXX-XXXX 형태로 입력해주세요.");
		} else if (req.tel2 === "") {
			delete req.tel2;
		}

		mutation.mutate(req);
	};

	return (
		<Modal isOpen={isEditCandidateModalOpen} onSubmit={handleSubmit(onSubmit)}>
			<form
				style={{
					display: "block",
				}}
				className="modal fade"
				id="user-info"
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabIndex="-1"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header flex">
							<p className="sign-top-title" id="staticBackdropLabel">
								OPIC 시험코드
							</p>
							<button
								type="button"
								className="close"
								onClick={() => setEditCandidateModalOpen(false)}
							></button>
						</div>
						<div className="modal-body confirm-sec">
							<div className="modal-title">
								<p>응시자 정보</p>
							</div>
							<div className="modal-cont">
								<div className="info-sec">
									<p className="info-sec-title">
										면접실
										<span>*</span>
									</p>
									<input type="text" className="info-input" disabled />
								</div>
								<div className="info-sec">
									<p className="info-sec-title">
										이름
										<span>*</span>
									</p>
									<input
										refs={{
											...register("name", {
												min: 2,
												max: 30,
											}),
										}}
										type="text"
										className="info-input"
									/>
								</div>
								<div className="info-sec">
									<p className="info-sec-title">
										이메일
										<span>*</span>
									</p>
									<input
										refs={{
											...register("email"),
										}}
										type="email"
										className="info-input"
									/>
								</div>
								<div className="info-sec">
									<p className="info-sec-title">
										면접코드(가번호)
										<span>*</span>
									</p>
									<input type="text" className="info-input" disabled />
								</div>
								<div className="info-sec">
									<p className="info-sec-title">생년월일(6자리)</p>
									<input
										refs={{
											...register("birthday"),
										}}
										type="text"
										className="info-input"
									/>
								</div>
								<div className="info-sec">
									<p className="info-sec-title">휴대폰번호</p>
									<input
										refs={{
											...register("tel"),
										}}
										type="text"
										className="info-input"
									/>
								</div>
								<div className="info-sec">
									<p className="info-sec-title">휴대폰번호(추가)</p>
									<input
										refs={{
											...register("tel2"),
										}}
										type="text"
										className="info-input"
									/>
								</div>
							</div>
						</div>
						<div className="modal-footer text-align-right">
							<button
								type="button"
								className="modal-btn modal-close-btn"
								data-bs-dismiss="modal"
								onClick={() => setEditCandidateModalOpen(false)}
							>
								닫기
							</button>
							<button type="submit" className="modal-btn modal-save-btn">
								저장
							</button>
						</div>
					</div>
				</div>
			</form>
		</Modal>
	);
};

export default CandidateEditModal;
